import React, {useEffect, useState} from 'react';
import AppContainer from "../../components/AppContainer";
import {useNavigate} from "react-router-dom";
import OpsBtn from "../../ops-library/ops-btn";
import OpsLogo from "../../ops-library/ops-logo";
import {BackgroundImages} from "../../components/AuthBackground";
import OpsText from "../../ops-library/ops-text";
import OpsInput from "../../ops-library/ops-input";
import axios from "axios";
import {Form} from "react-bootstrap";
import opsToast from "../../ops-library/ops-toast";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {isTokenExpired} from "../../functions/isTokenExpired";
import {AuthLoadingSpinner} from "../../components/AuthLoadingSpinner";


const Login = () => {

    const navigate = useNavigate()
    const [processed, setProcessed] = useState(false)
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);

    useEffect(() => {
        if (token && !isTokenExpired(token)) {
            navigate("/")
        }
    }, []);
    const LoginContent = () => {
        const [errorEmail, setErrorEmail] = useState(false);
        const [errorPassword, setErrorPassword] = useState(false);
        const [email, setEmail] = useState("");
        const [password, setPassword] = useState("");

        async function handleLogin(e) {
            e.preventDefault();

            if (email.length === 0) {
                opsToast("Nezadali ste email používateľa!", "error", "colored", true, "top-center")
                setErrorEmail(true);
            } else if (password.length === 0) {
                opsToast("Nezadali ste heslo používateľa!", "error", "colored", true, "top-center")
                setErrorPassword(true);
            } else {
                setProcessed(true)
                const configuration = {
                    method: "post",
                    url: `${process.env.REACT_APP_API_BASE_URL}/auth/login`,
                    data: {
                        email,
                        password
                    },
                };

                axios(configuration)
                    .then((result) => {
                        localStorage.setItem(ACCESS_TOKEN_KEY, result.data.token)
                        setErrorEmail(false);
                        navigate("/admin");
                    })
                    .catch((error) => {
                        setProcessed(false)
                        if (error.response?.request?.status === 404)
                            setErrorEmail(true);
                        else if (error.response?.request?.status === 400)
                            setErrorPassword(true);
                        opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                    });
            }
        }

        return (
            <div className="account-tab-container px-2 py-3 rounded-5 shadow-sm">
                <div className="account-tab-content">
                    <div className="fa-flex-col align-items-center mt-4">
                        <OpsLogo size="bg pointer-cursor" action={() => navigate("/")}/>
                        <OpsText type="title" className="mt-4"
                                 content={"Prihlásiť sa"}/>
                    </div>
                    <Form className="login-form px-4 w-100 mt-3"
                          onSubmit={(e) => handleLogin(e)}>
                        <OpsInput
                            error={errorEmail}
                            required
                            id="email"
                            type="email"
                            label="E-mail"
                            labelColor="color-2"
                            placeholder="Zadajte e-mail"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value)
                                setErrorEmail(false)
                            }}
                        />
                        <OpsInput
                            error={errorPassword}
                            required
                            customType="password"
                            id="password"
                            type="password"
                            label="Heslo"
                            labelColor="color-2"
                            placeholder="Zadajte heslo"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value)
                                setErrorPassword(false)
                            }}
                        />
                        <div className="invalid-feedback">
                            Please provide a valid city.
                        </div>

                        <OpsBtn text="Prihlásiť sa" type="submit" variant="primary w-100 mt-3"
                                action={(e) => handleLogin(e)}/>
                    </Form>
                    <div className="fa-flex-col mt-4">
                        <OpsBtn
                            btnText
                            text="Obnoviť zabudnuté heslo"
                            action={() => navigate("/obnovenie&uctu")}
                        />
                    </div>
                    {/*<OpsBtnGoogle btnStyle="mt-2" login/>*/}
                </div>
            </div>
        )
    }

    return (
        <AppContainer
            showFooter={false}
            showNavbar={false}
            showSlides={false}
            content={
                <div className="window-login-container">
                    <BackgroundImages/>
                    {processed ?
                        <AuthLoadingSpinner/>
                        :
                        <LoginContent/>
                    }
                </div>
            }
        />
    );
};

export default Login;